import { createHttpAction } from '@securitize/ui-components';
import {
  GET_OPPORTUNITY_ACCESS_NEXT,
  GET_OPPORTUNITY_BROKER_DEALER_NEXT,
  GET_OPPORTUNITY_NEXT,
  UPDATE_OPPORTUNITY_NEXT,
} from './actionTypes';

/**
 * @param {string} opportunityId
 * @param {*} options
 * @returns
 */
export const getOpportunity = (opportunityId, options) => createHttpAction(GET_OPPORTUNITY_NEXT(opportunityId), {}, options)
  .action;

export const updateOpportunity = (opportunityId, data, options) => createHttpAction(UPDATE_OPPORTUNITY_NEXT(opportunityId),
  { body: data }, options)
  .action;

export const getOpportunityBrokerDealer = (opportunityId, options) => createHttpAction(
  GET_OPPORTUNITY_BROKER_DEALER_NEXT(opportunityId), {}, options,
).action;

export const getOpportunityAccess = (opportunityId, options) => createHttpAction(GET_OPPORTUNITY_ACCESS_NEXT(opportunityId),
  {}, options).action;
